import { css } from 'styled-components';
import { responsiveProperty } from './responsiveProperty';
export const heightPropsNames = ['height', 'minHeight', 'maxHeight'];
export const heightProps = css `
  ${(props) => props.height && responsiveProperty('height', props.height)};
  ${(props) => props.minHeight && responsiveProperty('minHeight', props.minHeight)};
  ${(props) => props.maxHeight && responsiveProperty('maxHeight', props.maxHeight)};
`;
